export default "__VITE_ASSET__JSlupkRT__"